export const EDUCATORS_ITEMS = [
	{ year: "2021", title: "RELEMBRE A JORNADA DE AULAS 2021", link:"/jornada/EDUCATORS/2021", button:"Assista" },
	{ year: "2022", title: "DESCUBRA A JORNADA DE AULAS 2022", link:"/jornada/EDUCATORS/2022", button:"Assista" },
];
